import * as React from 'react';
import styled from 'styled-components';
import StarImage from '../../assets/ic-activity-highlight.png';
import {mobileMediaQuery} from '../../styles';

const ActivityTag = ({className, activity}) => {
    return (
        <Container className={className}>
            <Image src={StarImage} />
            <Text>{activity.type}</Text>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-shrink: 1;
    flex-direction: row;
    align-items: center;
    background-color: #7e7e7e;
    padding: 6px 12px;
    align-self: flex-end;
    border-radius: 100px;
    ${mobileMediaQuery} {
        padding: 4px 8px 4px 4px;
    }
`;

const Image = styled.img`
    margin-right: 6px;
`;

const Text = styled.p`
    color: white;
    font-family: Oduda;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    margin-block: 0;

    ${mobileMediaQuery} {
        font-size: 9px;
        margin-top: 2px;
    }
`;

export default ActivityTag;
